import { useUserInfoQuery } from '~/apis/auth';
import { useSelectedBrandId } from './useSelectedBrandId';

export const useClientBrandIds = () => {
  const { data: auth } = useUserInfoQuery();
  const { brandId } = useSelectedBrandId();
  return {
    brandId: brandId,
    clientId: auth?.client_id,
  } as {
    brandId: number;
    clientId: number;
  };
};
